// |--------------------------------------------------------------------------
// | KEEN SETTINGS
// |--------------------------------------------------------------------------

// Accounts that shouldn't be included in any analytics other than the account or account's user analytics page
// export const accountBlacklist = [180, 467, 585, 586, 587, 588, 589, 590, 591, 632, 679, 699, 713, 789, 823, 841, 843]
export const accountBlacklist = [
  26,
  180,
  298,
  467,
  486,
  585,
  586,
  587,
  588,
  589,
  590,
  591,
  595,
  632,
  679,
  699,
  713,
  728,
  782,
  789,
  823,
  829,
  839,
  840,
  841,
  843,
  848,
  871,
  923,
  1120,
  1172,
  1179,
  1226,
  1275,
  1330,
  1331,
  1332,
  1335,
  1337,
  1357,
  1359,
  1415,
  1458,
  1460,
  1465,
  1466,
  1504,
  1510,
  1532,
  1623,
  1708,
  1718,
  1734,
  1735,
  1739,
  1740,
  1742,
  1743,
  1745,
  1747,
  1758,
  1759,
  1768,
  1769,
  1784,
  3993,
  4309,
  4346,
  4350,
  4365,
  4380,
  4381,
  4383,
  4384,
  4385,
  4394,
  4397,
  4400,
  4405,
  4406,
  4407,
  4409,
  4421,
  4423,
  4427,
  4430,
  4431,
  4434,
  4435,
  4437,
  4440,
  4442,
  4445,
  4446,
  4453,
  4455,
  4458,
  4462,
  4466,
  4469,
  4480,
  4481,
  4483,
  4485,
  4486,
  4489,
  4494,
  4498,
  4499,
  4504,
  4505,
  4506,
  4507,
  4523,
  4526,
  4531,
  4545,
  4549,
  4554,
]
export const userBlacklist = [
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  14,
  15,
  16,
  17,
  18,
  19,
  20,
  21,
  37,
  38,
  39,
  40,
  41,
  42,
  43,
  49,
  52,
  99,
  110,
  125,
  163,
  173,
  176,
  187,
  234,
  238,
  246,
  251,
  270,
  282,
  291,
  302,
  303,
  304,
  307,
  322,
  338,
  365,
  371,
  469,
  568,
  636,
  638,
  653,
  718,
  724,
  740,
  805,
  875,
  962,
  1029,
  1089,
  1116,
  1209,
  1331,
  1407,
  1418,
  1433,
  1574,
  1578,
  1614,
  1712,
  1750,
  1760,
  1894,
  1910,
  1951,
  1966,
  2006,
  2020,
  2039,
  2117,
  2123,
  2126,
  2280,
  2290,
  2336,
  2363,
  2469,
  2483,
  2486,
  2534,
  3181,
  4743,
  5456,
  6996,
  7013,
  7018,
  7035,
  7038,
  7056,
  7058,
  7060,
  7062,
  7064,
  7067,
  7069,
  7071,
  7074,
  7076,
  7078,
  7090,
  7093,
  7102,
  7105,
  7119,
  7129,
  7131,
  9646,
  10041,
  10044,
  10141,
  10178,
  10437,
  27524,
  27541,
  27545,
  27565,
  27598,
  27613,
  27623,
  27667,
  27678,
  27679,
  27716,
  27994,
  28134,
  28244,
  28357,
  28595,
  28611,
  28743,
  28748,
  28756,
  29080,
  29084,
  29119,
  29672,
  29704,
  29707,
  29764,
  29779,
  29949,
  29950,
  29967,
  29968,
  29969,
  29971,
  29980,
  30023,
  30078,
  30170,
  30171,
  30182,
  30183,
  30234,
  30269,
  30332,
  30333,
  30426,
  30687,
  30768,
  31386,
  31463,
  31656,
]

export const attrTypes = {
  sendgrid: {
    primary_analyst_id: false,
    alertable_id: true,
    notifiable_id: true,
    alert_id: true,
    account_id: true,
  },
}

export const clientSideCache =
  process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'local'
    ? false
    : {
        maxAge: 1000 * 60 * 60,
      }

export const indexByTimezone = {
  email_article_views: 'time.timezone_offset',
  article_views: 'time.utc.timezone_offset',
  email_open: 'timestamp_info.timezone_offset',
  email_click: 'timestamp_info.timezone_offset',
  email_processed: 'timestamp_info.timezone_offset',
  email_delivered: 'timestamp_info.timezone_offset',
}

export const groupByTimezone = {
  email_article_views: 'time.week',
  article_views: 'time.utc.week',
}

export const intervalMap = {
  hour: 'hourly',
  day: 'daily',
  week: 'weekly',
  month: 'monthly',
  year: 'yearly',
}

export const queryOptions = {
  // email: {
  //   streams: ['email_article_views'],
  //   network: 'time.timezone_offset',
  //   channel: 'channel_id',
  //   account: 'account_id',
  //   user: 'user_id',
  //   analyst: 'primary_analyst_id',
  //   article: 'alertable_id',
  //   newsletter: 'alertable_id',
  //   alert: 'alert_id',
  // },
  // emailNewsletter: {
  //   streams: ['email_newsletter_views'],
  //   network: 'time.timezone_offset',
  //   channel: 'channel_id',
  //   account: 'account_id',
  //   user: 'user_id',
  //   analyst: 'primary_analyst_id',
  //   article: 'alertable_id',
  //   newsletter: 'alertable_id',
  //   alert: 'alert_id',
  // },
  web: {
    streams: ['article_views', 'article_downloads'],
    network: 'time.utc.timezone_offset',
    channel: 'channel_id',
    account: 'account_id',
    user: 'user_id',
    analyst: 'primary_analyst_id',
    article: 'alertable_id',
    newsletter: 'alertable_id',
    alert: 'alert_id',
  },
  sendgrid: {
    streams: ['email_processed', 'email_delivered', 'email_open', 'email_click'],
    network: 'timestamp_info.timezone_offset',
    networkNewsletterType: 'timestamp_info.timezone_offset',
    channel: 'channel_id',
    account: 'account_id',
    user: 'notifiable_id',
    analyst: 'primary_analyst_id',
    article: 'alertable_id',
    newsletter: 'alertable_id',
    alert: 'alert_id',
  },
}
